const VERSION = '6.9.3';

export { VERSION };
